import * as React from 'react';
import { formValueSelector, reduxForm } from 'redux-form';
import { get, isEmpty } from 'lodash';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withState } from 'recompose';
import { Col, Grid, Row } from 'react-flexbox-grid';

import RemoteAutoComplete, { RemoteAutoCompleteField } from '@components/form/RemoteAutoComplete/RemoteAutoComplete';

import OverviewForm from './OverviewForm';
import ExportButton from '@components/exportButton/ExportButton';
import { stringifyObject } from '@utils/utils';
import { AutoComplete, AutoCompleteField } from '@components/form';
import { connect } from 'react-redux';

const enhance = compose(
  reduxForm({ form: 'all-overviews' }),
  withState('employeeId', 'setEmployeeId', null),
  withState('stationId', 'setStationId', null),
  withState('shiftCycleId', 'setShiftCycleId', null),
  breadcrumbs([{ label: 'Personalistika - přehled zaměstnanců' }]),
  connect<any>((state, { form }: any) => {
    return {
      station: formValueSelector(form)(state, 'station'),
      shiftCycle: formValueSelector(form)(state, 'shiftCycle'),
      employee: formValueSelector(form)(state, 'employee')
    };
  })
);

const View: React.SFC<any> = ({
  employeeId,
  setEmployeeId,
  stationId,
  setStationId,
  shiftCycleId,
  setShiftCycleId,
  shiftCycle,
  station
}) => (
  <>
    <Grid fluid={true}>
      <Row>
        <Col md={3}>
          <RemoteAutoCompleteField
            component={RemoteAutoComplete}
            name="station"
            label="Pracoviště"
            url={`/metropolis/api/ed/stations`}
            labelFunction={o => get(o, 'name') || get(o, 'code')}
            filterActive={true}
            valueFunction={o => o}
            onChange={(value: any) => {
              setStationId(value.id);
            }}
          />
        </Col>
        <Col md={3}>
          <RemoteAutoCompleteField
            component={RemoteAutoComplete}
            name="shiftCycle"
            label="Cyklus směny"
            url={`/metropolis/api/hr/workplan/shift/cycle`}
            labelFunction={o => get(o, 'label')}
            valueFunction={o => o}
            onChange={(value: any) => {
              setShiftCycleId(value.id);
            }}
          />
        </Col>
        <Col md={3}>
          {(() => {
            if (!isEmpty(shiftCycle)) {
              return (
                <AutoCompleteField
                  component={AutoComplete}
                  label="Zaměstnanec"
                  name="employee"
                  labelFunction={o => get(o, 'fullName')}
                  valueFunction={o => get(o, 'id')}
                  items={shiftCycle && shiftCycle.employees}
                  onChange={value => {
                    const id = stringifyObject(value);
                    setEmployeeId(id);
                  }}
                />
              );
            } else if (!isEmpty(station)) {
              return (
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  label="Zaměstnanec"
                  name="employee"
                  labelFunction={o => get(o, 'fullName')}
                  valueFunction={o => get(o, 'id')}
                  url={`/metropolis/api/hr/workplan/shift/cycle/employees`}
                  params={{ stationId: station.id }}
                  onChange={value => {
                    const id = stringifyObject(value);
                    setEmployeeId(id);
                  }}
                />
              );
            } else {
              return (
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  label="Zaměstnanec"
                  name="employee"
                  labelFunction={o => get(o, 'fullName')}
                  valueFunction={o => get(o, 'id')}
                  url="/metropolis/api/hr/employees"
                  onChange={value => {
                    const id = stringifyObject(value);
                    setEmployeeId(id);
                  }}
                />
              );
            }
          })()}
        </Col>
        <Col md={3}>
          <ExportButton
            location="workPlanEvidenceOverview"
            formName="form.module-events"
            urlPrefix="/metropolis"
            exportLabel="Export"
            useFileNameDialog={true}
            disabled={isEmpty(employeeId) && isEmpty(stationId) && isEmpty(shiftCycleId)}
            defaultData={{ employeeId, stationId, shiftCycleId }}
          />
        </Col>
      </Row>
    </Grid>
    <OverviewForm employeeId={employeeId} />
  </>
);

export const AllOverviews = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-overview/AllOverviews.tsx